<script>
    import {API_URL} from "../../env";
    import Error from "../placeholders/Error.svelte";
    import ContentLoading from "../placeholders/ContentLoading.svelte";

    window.scrollTo(0, 0);

    let data = fetchData()

    async function fetchData() {
        const res = await fetch(API_URL+'/pages/terms');
        return await res.text()
    }
</script>

<div class="container">
    <section class="info-page mt-lg-5 mb-lg-5">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-8 col-lg-9">
                        <h2 class="section-title">Obchodné podmienky</h2>
                    </div>
                    <div class="col-12 col-md-4 col-lg-3 mt-2 mb-4 mt-md-0 mb-md-0 d-flex justify-content-end">
                        <a class="info-button align-self-center align-content-center w-100" target="_blank" href="/files/Odstupenie-od-kupnej-zmluvy-uzavretej-na-dialku.pdf"><i class="fas fa-fw fa-download mr-2"></i>Odstúpenie od kúpnej zmluvy</a>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="info-content">
                    {#await data}
                        <ContentLoading/>
                    {:then data}
                        {@html data}
                    {:catch error}
                        <Error/>
                    {/await}
                </div>
            </div>
        </div>
    </section>
</div>